import React from 'react'

export const Logo: React.FC = () => (
  <svg id="Logo" viewBox="0 0 80 18" width="67px" height="15px" fill="#000">
    <g>
      <path
        d="M0.9,16.4V1.8C0.9,1.5,1,1.3,1.2,1S1.7,0.7,2,0.7h8.9c4.7,0,7.1,2.2,7.1,6.5s-2.4,6.5-7.1,6.5H5.3v2.6
   c0,0.3-0.1,0.6-0.3,0.8s-0.5,0.3-0.8,0.3H2c-0.3,0-0.6-0.1-0.8-0.3S0.9,16.7,0.9,16.4z M5.3,10.5h4.3c1.3,0,2.3-0.2,3-0.7
   s1-1.3,1-2.6s-0.3-2.1-1-2.6S10.9,4,9.6,4H5.3V10.5z"
      />
      <path
        d="M20.2,16.4V1.8c0-0.3,0.1-0.6,0.3-0.8s0.5-0.3,0.8-0.3h2.2c0.3,0,0.6,0.1,0.8,0.3s0.3,0.5,0.3,0.8v14.6
   c0,0.3-0.1,0.6-0.3,0.8s-0.5,0.3-0.8,0.3h-2.2c-0.3,0-0.6-0.1-0.8-0.3S20.2,16.7,20.2,16.4z"
      />
      <path
        d="M26.8,2.9V1.8c0-0.3,0.1-0.6,0.3-0.8s0.5-0.3,0.8-0.3h13.7c0.3,0,0.6,0.1,0.8,0.3s0.3,0.5,0.3,0.8v1.3
   c0,0.3-0.1,0.6-0.2,0.9s-0.3,0.5-0.4,0.6l-0.5,0.5l-9.2,9h9.3c0.3,0,0.6,0.1,0.8,0.3s0.3,0.5,0.3,0.8v1.1c0,0.3-0.1,0.6-0.3,0.8
   s-0.5,0.3-0.8,0.3H28.1c-0.3,0-0.6-0.1-0.8-0.3S27,16.7,27,16.4v-1.3c0-0.8,0.4-1.5,1.1-2.2L37.1,4h-9.1c-0.3,0-0.6-0.1-0.8-0.3
   S26.8,3.2,26.8,2.9z"
      />
      <path
        d="M44,2.9V1.8c0-0.3,0.1-0.6,0.3-0.8s0.5-0.3,0.8-0.3h13.7c0.3,0,0.6,0.1,0.8,0.3s0.3,0.5,0.3,0.8v1.3
   c0,0.3-0.1,0.6-0.2,0.9s-0.3,0.5-0.4,0.6l-0.5,0.5l-9.2,9H59c0.3,0,0.6,0.1,0.8,0.3s0.3,0.5,0.3,0.8v1.1c0,0.3-0.1,0.6-0.3,0.8
   s-0.5,0.3-0.8,0.3H45.3c-0.3,0-0.6-0.1-0.8-0.3s-0.3-0.5-0.3-0.8v-1.3c0-0.8,0.4-1.5,1.1-2.2L54.3,4h-9.1c-0.3,0-0.6-0.1-0.8-0.3
   S44,3.2,44,2.9z"
      />
      <path
        d="M60.9,16.4l2.9-11.2c0.8-3,3.4-4.6,7.8-4.6H78c0.3,0,0.5,0.1,0.7,0.3S79,1.5,79,1.8v14.6
   c0,0.3-0.1,0.6-0.3,0.8s-0.5,0.3-0.8,0.3h-2.2c-0.3,0-0.6-0.1-0.8-0.3s-0.3-0.5-0.3-0.8v-3h-8.3l-0.8,3c-0.1,0.3-0.3,0.6-0.5,0.8
   c-0.3,0.2-0.6,0.3-0.9,0.3h-2.3c-0.3,0-0.5-0.1-0.7-0.3c-0.1-0.1-0.2-0.3-0.2-0.5C60.9,16.6,60.9,16.5,60.9,16.4z M67.2,10.1h7.4V4
   h-3.3c-0.7,0-1.4,0.2-2,0.6c-0.6,0.4-0.9,1-1.1,1.7L67.2,10.1z"
      />
    </g>
  </svg>
)

export const CloseIcon: React.FC<any> = (props) => (
  <svg
    id="Close"
    enableBackground="new 0 0 386.667 386.667"
    height="22"
    viewBox="0 0 386.667 386.667"
    width="22"
    fill="#fff"
    {...props}>
    <path d="m386.667 45.564-45.564-45.564-147.77 147.769-147.769-147.769-45.564 45.564 147.769 147.769-147.769 147.77 45.564 45.564 147.769-147.769 147.769 147.769 45.564-45.564-147.768-147.77z" />
  </svg>
)

export const SortIcon: React.FC = () => (
  <svg id="Sort" width="12px" height="12px" viewBox="0 0 511.627 511.627">
    <g>
      <path
        d="M333.584,438.536h-73.087c-2.666,0-4.853,0.855-6.567,2.573c-1.709,1.711-2.568,3.901-2.568,6.564v54.815
			c0,2.673,0.855,4.853,2.568,6.571c1.715,1.711,3.901,2.566,6.567,2.566h73.087c2.666,0,4.856-0.855,6.563-2.566
			c1.718-1.719,2.563-3.898,2.563-6.571v-54.815c0-2.663-0.846-4.854-2.563-6.564C338.44,439.392,336.25,438.536,333.584,438.536z"
      />
      <path
        d="M196.54,401.991h-54.817V9.136c0-2.663-0.854-4.856-2.568-6.567C137.441,0.859,135.254,0,132.587,0H77.769
			c-2.663,0-4.856,0.855-6.567,2.568c-1.709,1.715-2.568,3.905-2.568,6.567v392.855H13.816c-4.184,0-7.04,1.902-8.564,5.708
			c-1.525,3.621-0.855,6.95,1.997,9.996l91.361,91.365c2.094,1.707,4.281,2.562,6.567,2.562c2.474,0,4.665-0.855,6.567-2.562
			l91.076-91.078c1.906-2.279,2.856-4.571,2.856-6.844c0-2.676-0.859-4.859-2.568-6.584
			C201.395,402.847,199.208,401.991,196.54,401.991z"
      />
      <path
        d="M388.4,292.362H260.494c-2.666,0-4.853,0.855-6.567,2.566c-1.71,1.711-2.568,3.901-2.568,6.563v54.823
			c0,2.662,0.855,4.853,2.568,6.563c1.714,1.711,3.901,2.566,6.567,2.566H388.4c2.666,0,4.855-0.855,6.563-2.566
			c1.715-1.711,2.573-3.901,2.573-6.563v-54.823c0-2.662-0.858-4.853-2.573-6.563C393.256,293.218,391.066,292.362,388.4,292.362z"
      />
      <path
        d="M504.604,2.568C502.889,0.859,500.702,0,498.036,0H260.497c-2.666,0-4.853,0.855-6.567,2.568
			c-1.709,1.715-2.568,3.905-2.568,6.567v54.818c0,2.666,0.855,4.853,2.568,6.567c1.715,1.709,3.901,2.568,6.567,2.568h237.539
			c2.666,0,4.853-0.855,6.567-2.568c1.711-1.714,2.566-3.901,2.566-6.567V9.136C507.173,6.473,506.314,4.279,504.604,2.568z"
      />
      <path
        d="M443.22,146.181H260.494c-2.666,0-4.853,0.855-6.567,2.57c-1.71,1.713-2.568,3.9-2.568,6.567v54.816
			c0,2.667,0.855,4.854,2.568,6.567c1.714,1.711,3.901,2.57,6.567,2.57H443.22c2.663,0,4.853-0.855,6.57-2.57
			c1.708-1.713,2.563-3.9,2.563-6.567v-54.816c0-2.667-0.855-4.858-2.563-6.567C448.069,147.04,445.879,146.181,443.22,146.181z"
      />
    </g>
  </svg>
)

export const DeleteIcon: React.FC = () => (
  <svg height="15px" viewBox="-57 0 512 512" width="15px" fill="#fff">
    <path d="m156.371094 30.90625h85.570312v14.398438h30.902344v-16.414063c.003906-15.929687-12.949219-28.890625-28.871094-28.890625h-89.632812c-15.921875 0-28.875 12.960938-28.875 28.890625v16.414063h30.90625zm0 0" />
    <path d="m344.210938 167.75h-290.109376c-7.949218 0-14.207031 6.78125-13.566406 14.707031l24.253906 299.90625c1.351563 16.742188 15.316407 29.636719 32.09375 29.636719h204.542969c16.777344 0 30.742188-12.894531 32.09375-29.640625l24.253907-299.902344c.644531-7.925781-5.613282-14.707031-13.5625-14.707031zm-219.863282 312.261719c-.324218.019531-.648437.03125-.96875.03125-8.101562 0-14.902344-6.308594-15.40625-14.503907l-15.199218-246.207031c-.523438-8.519531 5.957031-15.851562 14.472656-16.375 8.488281-.515625 15.851562 5.949219 16.375 14.472657l15.195312 246.207031c.527344 8.519531-5.953125 15.847656-14.46875 16.375zm90.433594-15.421875c0 8.53125-6.917969 15.449218-15.453125 15.449218s-15.453125-6.917968-15.453125-15.449218v-246.210938c0-8.535156 6.917969-15.453125 15.453125-15.453125 8.53125 0 15.453125 6.917969 15.453125 15.453125zm90.757812-245.300782-14.511718 246.207032c-.480469 8.210937-7.292969 14.542968-15.410156 14.542968-.304688 0-.613282-.007812-.921876-.023437-8.519531-.503906-15.019531-7.816406-14.515624-16.335937l14.507812-246.210938c.5-8.519531 7.789062-15.019531 16.332031-14.515625 8.519531.5 15.019531 7.816406 14.519531 16.335937zm0 0" />
    <path d="m397.648438 120.0625-10.148438-30.421875c-2.675781-8.019531-10.183594-13.429687-18.640625-13.429687h-339.410156c-8.453125 0-15.964844 5.410156-18.636719 13.429687l-10.148438 30.421875c-1.957031 5.867188.589844 11.851562 5.34375 14.835938 1.9375 1.214843 4.230469 1.945312 6.75 1.945312h372.796876c2.519531 0 4.816406-.730469 6.75-1.949219 4.753906-2.984375 7.300781-8.96875 5.34375-14.832031zm0 0" />
  </svg>
)

export const MenuIcon: React.FC<any> = (props) => (
  <svg height="20px" width="20px" viewBox="0 0 384 384" fill="#000" {...props}>
    <g>
      <rect x="0" y="277.333" width="384" height="42.667" />
      <rect x="0" y="170.667" width="384" height="42.667" />
      <rect x="0" y="64" width="384" height="42.667" />
    </g>
  </svg>
)
